/**
 * server-decisions.ts — the ids of the buttons a team decides by, as the
 * server builds them to count a vote or a pool on: investing in a city,
 * placing its Wonder, buying a sub-fleet's aircraft, researching an
 * innovation. A hover on the button approves, or joins the pool; the server
 * derives the id of the decision it is asked to carry out and counts whoever
 * is on that exact string. An id that drifted on one side alone breaks the
 * decision in play: a vote never reaches its majority ("Need N/M online
 * members to approve"), and a pool leaves out the teammates who joined it.
 *
 * MIRRORS CityInvestButtonID (city-access.go), WonderButtonID
 * (commercial-messages.go), FleetBuyButtonID (fleets.go) and
 * InnovationButtonID (innovation.go); client_parity_test.go reads these
 * templates and holds the two together, so each stays a function of one
 * value returning one template. Dependency-free, so the scripts that play the
 * game import it too.
 */

/** The team's vote to invest in a city — its unlock, the first time. */
export function cityInvestButtonId(cityId: number): string {
  return `city-unlock-${cityId}`;
}

/** The team's vote to place the Wonder in a city. */
export function wonderButtonId(cityId: number): string {
  return `commercial-place_wonder-${cityId}`;
}

/**
 * A sub-fleet's Buy, keyed by its place in the fleet rather than by model:
 * two sub-fleets can hold the same aircraft, and a model-keyed id would let a
 * teammate co-sign the wrong one's purchase. (The cash pool is switched off
 * today; the id is held for when it returns.)
 */
export function fleetBuyButtonId(slotIndex: number): string {
  return `fleet-buy-${slotIndex}`;
}

/** An innovation's research: teammates on it share its Knowledge cost. */
export function innovationButtonId(innovationId: string): string {
  return `innovation-unlock-${innovationId}`;
}
